module.exports = __webpack_public_path__ + "static/media/puzzle01.9eed190d.png";